/* tslint:disable */
/* eslint-disable */
/**
 * pricing API
 * Pricing service
 *
 * The version of the OpenAPI document: 38.846.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApplicationContextClassLoaderParent } from './ApplicationContextClassLoaderParent';
import {
    ApplicationContextClassLoaderParentFromJSON,
    ApplicationContextClassLoaderParentFromJSONTyped,
    ApplicationContextClassLoaderParentToJSON,
} from './ApplicationContextClassLoaderParent';
import type { ApplicationContextClassLoaderParentDefinedPackagesInner } from './ApplicationContextClassLoaderParentDefinedPackagesInner';
import {
    ApplicationContextClassLoaderParentDefinedPackagesInnerFromJSON,
    ApplicationContextClassLoaderParentDefinedPackagesInnerFromJSONTyped,
    ApplicationContextClassLoaderParentDefinedPackagesInnerToJSON,
} from './ApplicationContextClassLoaderParentDefinedPackagesInner';
import type { ApplicationContextClassLoaderParentUnnamedModule } from './ApplicationContextClassLoaderParentUnnamedModule';
import {
    ApplicationContextClassLoaderParentUnnamedModuleFromJSON,
    ApplicationContextClassLoaderParentUnnamedModuleFromJSONTyped,
    ApplicationContextClassLoaderParentUnnamedModuleToJSON,
} from './ApplicationContextClassLoaderParentUnnamedModule';

/**
 * 
 * @export
 * @interface ApplicationContextClassLoader
 */
export interface ApplicationContextClassLoader {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoader
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoader
     */
    registeredAsParallelCapable?: boolean;
    /**
     * 
     * @type {ApplicationContextClassLoaderParent}
     * @memberof ApplicationContextClassLoader
     */
    parent?: ApplicationContextClassLoaderParent;
    /**
     * 
     * @type {ApplicationContextClassLoaderParentUnnamedModule}
     * @memberof ApplicationContextClassLoader
     */
    unnamedModule?: ApplicationContextClassLoaderParentUnnamedModule;
    /**
     * 
     * @type {Array<ApplicationContextClassLoaderParentDefinedPackagesInner>}
     * @memberof ApplicationContextClassLoader
     */
    definedPackages?: Array<ApplicationContextClassLoaderParentDefinedPackagesInner>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoader
     */
    defaultAssertionStatus?: boolean;
}

/**
 * Check if a given object implements the ApplicationContextClassLoader interface.
 */
export function instanceOfApplicationContextClassLoader(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApplicationContextClassLoaderFromJSON(json: any): ApplicationContextClassLoader {
    return ApplicationContextClassLoaderFromJSONTyped(json, false);
}

export function ApplicationContextClassLoaderFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationContextClassLoader {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'registeredAsParallelCapable': !exists(json, 'registeredAsParallelCapable') ? undefined : json['registeredAsParallelCapable'],
        'parent': !exists(json, 'parent') ? undefined : ApplicationContextClassLoaderParentFromJSON(json['parent']),
        'unnamedModule': !exists(json, 'unnamedModule') ? undefined : ApplicationContextClassLoaderParentUnnamedModuleFromJSON(json['unnamedModule']),
        'definedPackages': !exists(json, 'definedPackages') ? undefined : ((json['definedPackages'] as Array<any>).map(ApplicationContextClassLoaderParentDefinedPackagesInnerFromJSON)),
        'defaultAssertionStatus': !exists(json, 'defaultAssertionStatus') ? undefined : json['defaultAssertionStatus'],
    };
}

export function ApplicationContextClassLoaderToJSON(value?: ApplicationContextClassLoader | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'registeredAsParallelCapable': value.registeredAsParallelCapable,
        'parent': ApplicationContextClassLoaderParentToJSON(value.parent),
        'unnamedModule': ApplicationContextClassLoaderParentUnnamedModuleToJSON(value.unnamedModule),
        'definedPackages': value.definedPackages === undefined ? undefined : ((value.definedPackages as Array<any>).map(ApplicationContextClassLoaderParentDefinedPackagesInnerToJSON)),
        'defaultAssertionStatus': value.defaultAssertionStatus,
    };
}

